import { Pipe, PipeTransform } from '@angular/core';
import { ApproveStatus } from '@shared/enums/dpr';
import { DprCard } from '@dpr/models';
import { DprOnlineApproval } from '@shared/models/dpr';
import { DprApprovalStatusSummaryReport } from '@report/models';

@Pipe({
  name: 'approveStatusIcon',
})
export class ApproveStatusIconPipe implements PipeTransform {
  transform(
    data: DprOnlineApproval | DprCard | DprApprovalStatusSummaryReport,
    property: string,
    isOverallStatus = false,
    isModalOpen = false
  ): string {
    if (isOverallStatus) {
      switch (data?.[property]) {
        case ApproveStatus.Rejected:
          return 'account-cancel';
        case ApproveStatus.Seen:
          return 'account-eye';
        case ApproveStatus.Accepted:
          return 'account-check';
        case ApproveStatus.NotApproved:
        default:
          return 'account-clock';
      }
    } else {
      switch (data?.[property]) {
        case ApproveStatus.Rejected:
          return 'cancel';
        case ApproveStatus.Seen:
          return 'eye';
        case ApproveStatus.Accepted:
          return isModalOpen ? 'check' : 'check-circle';
        case ApproveStatus.NotApproved:
        default:
          return 'clock-outline';
      }
    }
  }
}
